export interface IUser {
  userID: string;
  phoneNumber?: string;
  phoneNumberConfirmed: boolean;
  emailConfirmed: boolean;
  lockoutEnabled: boolean;
  roles?: string[];
  companyCategories?: string[];
  assignedCountRequests?: number;

  email?: string;
  name?: string;
  password?: string;
  surname?: string;
  userName?: string;
  companyName?: string;
  customerID?: string;
  customerName?: string;
}

export class User implements IUser {
  userID: string;
  phoneNumber?: string;
  phoneNumberConfirmed: boolean;
  emailConfirmed: boolean;
  lockoutEnabled: boolean;
  roles?: string[];
  assignedCountRequests?: number;
  companyCategories?: string[];

  email?: string;
  name?: string;
  password?: string;
  surname?: string;
  userName?: string;
  companyName?: string;
  customerID?: string;
  customerName?: string;

  constructor();
  constructor(obj: IUser);
  constructor(obj?: IUser) {
    this.userID = obj?.userID ?? '';
    this.phoneNumber = obj?.phoneNumber;
    this.phoneNumberConfirmed = obj?.phoneNumberConfirmed ?? false;
    this.emailConfirmed = obj?.emailConfirmed ?? false;
    this.lockoutEnabled = obj?.lockoutEnabled ?? false;
    this.roles = obj?.roles;
    this.assignedCountRequests = obj?.assignedCountRequests ?? 0;
    this.companyCategories = obj?.companyCategories ?? [];

    this.email = obj?.email ?? '';
    this.name = obj?.name ?? '';
    this.password = obj?.password ?? '';
    this.surname = obj?.userName ?? '';
    this.userName = obj?.userName ?? '';
    this.companyName = obj?.companyName ?? '-';
    this.customerID = obj?.customerID ?? '';
    this.customerName = obj?.customerName ?? '-';
  }
}
